/****************************************************
 * Module Name:  KapanCreationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class KapanCreationProxy {
  static GetAllKapanCreation = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMyKapanDetail = (kapanid, frompacketid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/kapan/${kapanid}/packet/${frompacketid}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllKapanCreationByStatus = (status, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation/status",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(status),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetKapanList = (id, callback) => {
    restAPICall(Constants.MANAGER_URL + `/kapancreation/kapan/audit`, 'post', Constants.userToken, undefined, JSON.stringify(id), 'application/json', 0)
      .then(response => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetKapanHistoryDetail = (id, callback) => {
    restAPICall(Constants.MANAGER_URL + `/kapancreation/kapan/detail`, 'post', Constants.userToken, undefined, JSON.stringify(id), 'application/json', 0)
      .then(response => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static AddPacketRemarkCategory = (data, callback) => {
    restAPICall(Constants.MANAGER_URL + `/packetremark`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
      .then(response => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static AddPacketLossRemarkCategory = (data, callback) => {
    restAPICall(Constants.MANAGER_URL + `/packetloss`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
      .then(response => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetSingleKapanDetail = (kapanId, packekId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/kapan/${kapanId}/${packekId}/audit`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleKapanCreation = (kapancreationId, callback) => {
    let params = {
      id: kapancreationId,
    };

    restAPICall(
      Constants.MANAGER_URL + `/kapancreation`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetKapanCreationByUserId = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/mylot`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetKapanCreationForReceiveByUserId = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/mylot/receive`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckKapanCreationAvailable = (kapancreation, callback) => {
    let params = {
      lotid: kapancreation,
    };

    restAPICall(
      Constants.MANAGER_URL + "/kapancreation/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddKapanCreation = (kapancreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(kapancreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateKapanCreation = (kapancreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(kapancreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteKapanCreation = (kapancreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(kapancreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static KapanCreationReport = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation/report",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddIssue = (kapancreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation/issue",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(kapancreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CancelIssue = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/cancel`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static NotifyUser = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/notify`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static AddPackageEvaluation = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/packetevaluation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddReceive = (kapancreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/kapancreation/mylot/receive",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(kapancreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllKapanAuditByKapanId = (kapanid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapanaudit/${kapanid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CloseKapanPackaging = (kapanid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/close/${kapanid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
